import Input from "../reusable-components/input"

const AccountInfo = ({ auth, register }) => {
  const logout = async () => {
    await auth.signOut()
    window.location.reload()
  }

  return (
    <div className="flex flex-col md:flex-row gap-8">
      <div className="rounded-full bg-black font-bold text-2xl w-10 h-10 text-white flex items-center justify-center flex-shrink-0">
        2
      </div>

      <div className="flex flex-col gap-4">
        <p className="font-bold text-2xl whitespace-nowrap">Account Info.</p>
        <div className="flex items-center gap-2">
          <p className="w-32">Full Name</p>
          <Input
            name="name"
            type="string"
            placeholder="Full Name"
            disabled={!!auth.currentUser}
            register={register}
            required
          />
        </div>

        <div className="flex items-center gap-2">
          <p className="w-32">Email</p>
          <Input
            name="email"
            type="string"
            placeholder="Email"
            disabled={!!auth.currentUser}
            register={register}
            required
          />
        </div>

        {auth.currentUser ? (
          <p className="text-slate-500">
            Not {auth.currentUser.displayName}?{" "}
            <span
              className="underline cursor-pointer text-[#652cb3]"
              onClick={logout}>
              Log out
            </span>
          </p>
        ) : (
          <>
            <p className="text-slate-500">
              Already have an account?{" "}
              <a
                href={`${process.env.REACT_APP_FLEXDAY_URL}/login?redirectUrl=${process.env.REACT_APP_FLEXDAY_URL}/cart`}
                className="underline text-[#652cb3]">
                Log in
              </a>
            </p>
            <p className="text-xs bg-purple-200 italic w-fit self-center p-2 max-w-3xl">
              <span className="font-bold">NOTE:</span> You need to have a
              Flexday Account to submit your order. Enter your full name and
              email above, and proceed to Summary to review and submit your
              order. Your Flexday Account will automatically be created with
              your submitted order, and an email link will be sent for you to
              reconfirm your Flexday Account.
            </p>
          </>
        )}
      </div>
    </div>
  )
}

export default AccountInfo
